import { createAsyncThunk } from '@reduxjs/toolkit';
import { _teleServicePriceUrls } from '@custom/Utils/constants/apiUrls';

interface payloadType {
  limit: number;
  pageNumber: number;
  search: string;
}

// Async thunk to get all teleservice prices
export const getTeleServicePrice = createAsyncThunk(
  'getTeleServicePrice',
  async (payload: payloadType, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const response = await fetch(`${_teleServicePriceUrls?.get}?page=${payload?.pageNumber}&limit=${payload?.limit}&search=${payload?.search}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response?.ok) {
        return rejectWithValue(`Failed to fetch teleservice prices. Status code: ${response?.status}`);
      }

      return await response.json(); // Return the fetched data if successful
    } catch (error: any) {
      return rejectWithValue(error.message); // Handle any errors that occur
    }
  }
);

// You can export all thunks together if needed
export default getTeleServicePrice;
